import { ErrorResponse } from '@models/error.response';
import { TranslateService } from '@ngx-translate/core';
import { MainComponent } from '../main/main.component';
import { of, from } from 'rxjs';
import { ActionType } from '@type/action.type';
import { AppConstant } from '@constants/app.constant';
import { NgForm } from '@angular/forms';
import { FormValidationUtil } from '@utils/form.validation';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Component, ElementRef, QueryList, ViewChild, ViewChildren } from '@angular/core';
import swal from 'sweetalert2';
import { switchMap, map, flatMap, filter, toArray, mergeMap, reduce } from 'rxjs/operators';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgSelectUtil } from '@app/utils/ng-select-utils';
import { ModulePathConstant } from '@app/constants/modulePath.constant';
// import * as DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import * as WangEditor from 'wangeditor/release/wangEditor.js';
// import { CKEditor5 } from '@ckeditor/ckeditor5-angular';
import { BinaryFile } from '@app/models/binary-file';
import { CommonService } from '@app/services/common.service';
import { UploadOutput } from 'ngx-uploader';
import { ApplicationFile } from '@app/models/application-file';
import { BinaryFileService } from '@app/services/binary-file.service';
import * as FileSaver from 'file-saver';
import { Order } from '@app/models/order';
import { OrderService } from '@app/services/order.service';
declare var toastr: any;



const MAX_DOCUMENT_FILE_SIZE: number = 4 * 1024 * 1024;
@Component({
    templateUrl: './order-setup.component.html',
    styleUrls: ['./order-setup.component.scss']
})
export class OrderSetupComponent {
    @ViewChildren(NgSelectComponent) ngSelects: QueryList<NgSelectComponent>;
    @ViewChild('documentFileSelect', { static: false }) documentFileSelect: ElementRef;
    selectAll = NgSelectUtil.selectAll
    @ViewChild('form', { static: false }) form: NgForm;
    isFieldError = FormValidationUtil.isFieldError;
    action: ActionType;
    loading: boolean = false;
    fileLoading: boolean = false;

    isMaxCount: boolean = false;

    isShowAdd: boolean = false;
    isShowUpdate: boolean = false;
    recordLang: string = 'en';

    
    columnIdLabelList: []=[];
    allDataFromRemote: any={};

    binaryFileApplication: ApplicationFile;

    // Editor = DecoupledEditor;
    wangEditor: WangEditor;

    ngxWangConfig = {
        menus: ['head', 'bold', 'fontSize', 'fontName', 'italic', 'underline', 'foreColor', 'backColor','list', 'justify'],
        colors: ['#000000', '#eeece0', '#1c487f', '#4d80bf', '#c24f4a', '#8baa4a', '#7b5ba1', '#46acc8', '#f9963b', '#ffffff'],
        lang: {
            '设置标题': 'title',
            '正文': 'p',
            '字号': 'font size',
            '文字颜色': 'text color',
            '背景色': 'background color',
            '设置列表': 'list',
            '有序列表': 'ordered list',
            '无序列表': 'unordered list',
            '对齐方式': 'algin',
            '靠左': 'algin left',
            '居中': 'algin center',
            '靠右': 'algin right'
        }
    }


    attachmentOptions: BinaryFile[] = [];
    record: Order;
    isPrinting: boolean= false;


    orderColumnsPattern = [
        {key:"orderDate", label:"Order Date"},
        {key:"button4ProductName", label:"Product Name"},
        {key:"{TEMPLATE_FIELD}", label:""},
        {key:"num", label:"Number"},
        {key:"price", label:"Unit Price"},
        {key:"curr", label:"Currency"},
        {key:"amt", label:"Total Amount"},
        {key:"merCode", label:"Merchant Code"},
        {key:"merRef", label:"Order RefNo"},
        {key:"quotaSet", label:"Quota"},
        {key:"quotaLeft", label:"Quota Left"},
        {key:"isCustomPrice", label:"Custom Price"},
        {key:"customPriceMessage", label:"Custom Price Message"},
        {key:"lang", label:"Language"},
        {key:"pageUrl", label:"Page Url"}
    ];
    
    show4Merchant:boolean = true;
		


    constructor(
        private orderService: OrderService,
        private router: Router,
        private route: ActivatedRoute,
        private mainComponent: MainComponent,
        private commonService: CommonService,
        private binaryFileService: BinaryFileService,
        private translate: TranslateService,
        public appConstant: AppConstant) {
            var showall = this.commonService.getParamFromUrl("showall");
            if(showall=="true"){
                this.show4Merchant = false;
            }
    }

    ngOnInit(): void {
        this.record = new Order();

        this.route.params
            .pipe(
                switchMap((params: Params) => {
                    this.loading = true;
                    if (params['id'] === 'new') {
                        this.action = 'CREATE';
                        this.isShowAdd = this.commonService.showAddButton(this.action, 'PERM_ROLE_CREATE');
                    } else {
                        this.action = 'EDIT';
                        this.isShowUpdate = this.commonService.showUpdateButton(this.action, 'PERM_ROLE_UPDATE');
                    }
                    return of(params);
                }),
                switchMap((params: Params) => {
                    this.attachmentOptions = []
                    return of(params);
                    // return this.adminUserSerice.findAll()
                    //     .pipe(
                    //         map(users => {
                    //             this.userOptions = users;
                    //             return params;
                    //         })
                    //     );
                }),
                switchMap((params: Params) => {
                    if (this.action == 'CREATE') {
                        return of(new Order());
                    } else {
                        return this.orderService.get(params['id'])
                    }
                })
            )
            .subscribe((emailTemplate: Order) => {
                this.record = emailTemplate;
                if(this.show4Merchant){
                    this.columnIdLabelList = this.record.columnIdLabelList;
                    this.allDataFromRemote = this.record.allDataFromRemote[0];
                }else{
                    this.record.remoteData=this.record.allDataFromRemote[0];
                    this.recordLang = this.record.remoteData['lang'];
                    this.attachMapKey =  Object.keys(this.record.remoteData);
                    // this.removeUnshownKey();
                    this.attachMapKey.sort();
                }
                
                this.loading = false;
            });

    }

    // removeUnshownKey(){
    //     this.removeItem(this.attachMapKey, 'button4ProductName');
    //     this.removeItem(this.attachMapKey, 'quotaBookId');
    //     this.removeItem(this.attachMapKey, 'quotaRowId');
    //     this.removeItem(this.attachMapKey, 'id');
    //    // this.removeItem(this.attachMapKey, 'orderDate');
    //     this.removeItem(this.attachMapKey, 'createdAt');
    //     this.removeItem(this.attachMapKey, 'templateId');
    //    // this.removeItem(this.attachMapKey, 'productCode');
    //     this.removeItem(this.attachMapKey, 'companyEmail');
    // }

    printOneOrder(){
        this.isPrinting = true;
        setTimeout(() => {
            window.print();
           // history.go(-1);
            this.isPrinting = false;
           }, 20);
    }

    changeValueTodisplay(attributeKey, attrVal){
        if(attributeKey=='amt'){
            return parseFloat(attrVal)/100;
        }
        return attrVal;
    }

    removeItem(arr, itemval){
        var ix = arr.indexOf(itemval);
        if(ix>=0){
            arr.splice(ix,1);
        }
    }

    attachMapKey: any;


    getKeyLabel(fieldKey): string{
        var lang = this.record.remoteData['lang'];
        if(!lang){
            lang = 'EN';
        }
        if(this.record.orderFieldLabels){
            var fieldlabel = this.record.orderFieldLabels[fieldKey+"_"+lang.toUpperCase()];
            if(fieldlabel){
                return  fieldlabel;
            }
        }

        return fieldKey;
    }


    removeDocuments(): void {
        if (!this.record.htmlTemplate || this.record.htmlTemplate.fileName == null) {
            return;
        }
        this.record.htmlTemplate._selected = true;
        this.record.htmlTemplate = null;
        this.documentFileSelect.nativeElement.value = '';
    }
    

    public onAttachmentUploadOutput(output: UploadOutput): void {
        if (output.file != null) {
            this.binaryFileApplication = null;
            if (this.record.htmlTemplate == null) {
                this.record.htmlTemplate = new BinaryFile();
            }
            this.binaryFileApplication = new ApplicationFile(output.file, null, MAX_DOCUMENT_FILE_SIZE);
            this.binaryFileApplication.readAsBase64((result) => {
                this.record.htmlTemplate.content = result;
                this.record.htmlTemplate.fileName = output.file.name;
                this.record.htmlTemplate.fileSize = output.file.size;
                this.record.htmlTemplate._fileName = output.file.name;
                this.record.htmlTemplate._selected = true;
                this.documentFileSelect.nativeElement.value = '';
            })
        }
    }

    isSystemFile():boolean{
        return this.record.type == 'SYSTEM';
    }



    downloadFile() {
        let item = this.record.htmlTemplate;
        this.fileLoading = true;
        item._selected = true;
        this.binaryFileService.downloadFile(item.binaryFileId)
            .subscribe(blob => {

                FileSaver.saveAs(blob, item.fileName);
                this.fileLoading = false;
                item._selected = false;
            }, (error: ErrorResponse) => {
                this.fileLoading = false;
                item._selected = false;
                from(error.errors)
                    .pipe(
                        mergeMap(error => this.translate.get(error.errorCode)),
                        reduce((acc, value) => acc + value + '<br/>', '')
                    )
                    .subscribe(msg => {
                        this.translate.get(item.fileName)
                            .pipe(
                                switchMap(typeStr => this.translate.get('FAIL_TO_DOWNLOAD', { type: typeStr }))
                            )
                            .subscribe(title => {
                                toastr.options = {
                                    "closeButton": true,
                                    "positionClass": "toast-bottom-right",
                                    "timeOut": "0",
                                    "extendedTimeOut": "0"
                                }
                                toastr.error(msg, title);
                            });
                    });
            })
    }

    showDownloadButton() {
        if (!this.record || !this.record.htmlTemplate) {
            return false;
        }
        return this.record.htmlTemplate.binaryFileId != null && !(this.record.htmlTemplate._selected)
    }

    save(): void {

        // if (this.wangEditor) {
        //     console.info(this.wangEditor.txt.html() + '****');
        // }

        //check form for just clicking save without any input
        for (let key of Object.keys(this.form.controls)) {
            this.form.controls[key].markAsDirty();
        }

        if (this.form.valid) {

            switch (this.action) {
                case 'CREATE':
                    this.create();
                    break
                case 'EDIT':
                    this.update();
                    break;
            }
        }
    }

    private create(): void {
 
    }

    private update(): void {
 
    }

    cancel(): void {
        this.router.navigate([ModulePathConstant.ORDER_PATH]);
    }


}
